import { IngredientAction } from './ingredient-action.enum';
import { OrderableQualifier, OrderableIngredient } from 'ngx-web-api';
import { StageIngredient } from './stage-ingredient.model';

export class StageIngredientAction {
  orderableIngredient?: OrderableIngredient;
  stageIngredient?: StageIngredient;
  name?: string;
  action: IngredientAction;
  left?: boolean;
  right?: boolean;
  qualifier?: OrderableQualifier;
  orderedQualifierList?: string[];

  static hasOrderedSideQualifier(ingredient: OrderableIngredient, orderedQualifiers: string[]) {
    const sideQualName = ingredient?.qualifiers?.find(q => q.type === 'Side')?.name;
    return !!sideQualName && orderedQualifiers?.includes(sideQualName);
  }
}
